<template>
    <div class="text-center">
        <photo-viewer
            :photoFn="getPhotosFn(params)"
        >
        </photo-viewer>
    </div>
</template>

<script>
import Vue from 'vue';
import PhotoViewer from '@/components/Image/PhotoViewer';
import Assets from '@/services/Assets/Assets';

export default Vue.extend({
  components: {
    PhotoViewer,
  },
  methods: {
    getPhotosFn(params) {
      const { propertyAssetId } = params.data;
      const { propertyId } = this.$route.params;
      return () => Assets.getPhotos(propertyId, propertyAssetId);
    },
  },
});
</script>

<style lang="scss">
.overflow-cell {
    overflow: visible;
}

.ag-row {
    z-index: 0;

    &.ag-row-focus {
        z-index: 1;
    }
}
</style>
